import React from 'react';
import styles from '../../assets/styles/styles.less';
import MediaQuery from 'react-responsive';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { hashHistory } from 'react-router';


import MessageMobile from './MessageMobile';
import { Loading } from '../Controls';

import { messageFieldOnChange } from '../../actions/actions.js';

class Message extends React.Component {
	
    componentWillMount(){
        if (!this.props.reducer 
        || this.props.reducer.success   // submitted already    
        || !this.props.reducer.target.valid
        || Object.keys(this.props.reducer.charity).length === 0) hashHistory.push('/');
    }

    render() {
        return (
            <div>
                <MessageMobile {...this.props}/>
            </div> 
        )
    }

};

function mapStateToProps(state) {
  return {
    reducer: state.detailsReducer
  }
};

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    messageFieldOnChange 
}, dispatch)
};

export default connect(mapStateToProps, matchDispatchToProps)(Message);


// WEBPACK FOOTER //
// ./components/Message/Message.js